
import React, { memo } from 'react';
import { Icon } from '../../../ui-kit';
import HelpCenterButton from '../../../common/components/HelpCenterButton';
import '../styles/_no-organisations.scss';

function NoOrganisations() {
  return (
    <div className="no-organisations">
      <div className="no-organisations__inner">
        <Icon className="no-organisations__inner__icon" name="organisation" color="monkey" />
        <div className="no-organisations__inner__text">
          <p className="no-organisations__inner__text__header">{'You don\'t seem to be a member of any Organisations'}</p>
          <p className="no-organisations__inner__text__suggest">{'You\'re in the HUB but you need an invite.'}</p>
        </div>
      </div>
      <p className="no-organisations__assist">
        Contact your Organisation / Team Admin or visit our
        {' '}
        <HelpCenterButton />
        {' '}
        for more information.
      </p>
    </div>);

}

export default memo(NoOrganisations);